<template>
    <div class="main f-column">
        <div class="header f-row">
            <navigation v-if="IsAuthenticated"></navigation>
            <heat-head></heat-head>
            <connection-state></connection-state>
            <logo></logo>
        </div>
        <div class="body f-wrap" id="contentBody" :class="{'full-screen': isHeatEditing }">
            <router-view>

            </router-view>
        </div>
    </div>
</template>

<script>

import { mapGetters } from 'vuex';
import Logo from './Logo.vue';
import CompetitionDeck from './CompetitionDeck.vue';
import Login from './Login.vue';
import Navigation from './Navigation.vue';
import ConnectionState from './ConnectionState.vue';
import HeatHead from './HeatHead'

export default {
	name: 'BaseStruct',
	components: {
		Logo,
		CompetitionDeck,
		Login,
        Navigation,
        ConnectionState,
        HeatHead,
    },
    computed: {
        ...mapGetters(['IsAuthenticated', 'SelectedHeat']),
        isHeatEditing(){
            return this.SelectedHeat != '' && this.SelectedHeat != null && this.$route.path.includes('/event/');
        }
    }
};
</script>

<style lang="scss" scoped>

    @import "../../assets/styles/_globals";

    .main {
        min-height: 100vh;
    }

    .header {
        height:$height_mid;
        box-shadow: 0px 2px 2px $seltec_color;
        z-index: 10;
    }

    .footer {
        height:$height_default;
    }

    .body {
        flex-grow: 1;
        background-color:$prim_bg_color;
        padding: $spacer_s/2;
        overflow: auto;
        max-width:$body_max_width;
        background-color: #666;
        margin: 0 auto;
        margin-top: $spacer_s;
        box-sizing: border-box;
        width: 100%;
    }

    .full-screen {
        max-width: 100vw;
        margin-top: 0px;
        padding:0px;
        background-color:$prim_bg_color;
    }

    @media screen and (max-width: $body_max_width) {       
        .body {
            margin-top: 0px;
            padding:0px;
        }
    }
</style>
